module.exports = __webpack_public_path__ + "media/01.bb529cb9.mp3";